import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';

export type DialogProps = {
    title: string;
    message: string;
    type: 'success' | 'error';
    fileNames?: string[];
    onClose?: () => void;
};

export function UploadStatusDialog({type, title, message, fileNames, onClose: externalOnClose}: DialogProps) {
    const {onClose: ownOnClose} = RsnDialog.useControls();
    const onClose = () => {
        ownOnClose?.();
        externalOnClose?.();
    };
    return (
        <RsnDialog.Window placement='bottom' onClose={onClose}>
            <RsnDialog.CenteredHeader
                icon={{
                    element: <RsnDialog.StatusIcon status={type === 'success' ? 'check' : 'alert'} />,
                }}
            >
                {title}
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>
                <div className='whitespace-pre-wrap break-words'>
                    {message}
                    {!!fileNames?.length && (
                        <div>
                            <div className='mt-2'>Files that could not be uploaded:</div>
                            <div className='fv-text-l-bold'>{fileNames.join(', ')}.</div>
                        </div>
                    )}
                </div>
            </RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Secondary onClick={onClose}>I got it</RsnButton.Secondary>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
